(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4993],{

/***/ 44890:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metals-stones/[uid]/[page]",
      function () {
        return __webpack_require__(56323);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PageViewAnalytics; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13711);



function PageViewAnalytics(param) {
    var template = param.template;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = "".concat(router === null || router === void 0 ? void 0 : router.locale).concat(router === null || router === void 0 ? void 0 : router.pathname);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .WA, {
        template: template,
        pathname: pathname
    });
}


/***/ }),

/***/ 53299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WQ": function() { return /* binding */ IMAGE_SIZE; },
/* harmony export */   "eM": function() { return /* binding */ IMAGE_SIZES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95348);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51025);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72487);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);










var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()));
var IMAGE_SIZE = {
    LARGE: "large",
    SMALL: "small"
};
var _obj;
var IMAGE_SIZES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, IMAGE_SIZE.LARGE, [
    {
        breakpoint: "md",
        ratio: 2 / 3
    },
    {
        ratio: 1
    }
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, IMAGE_SIZE.SMALL, [
    {
        breakpoint: "md",
        ratio: 1 / 3
    },
    {
        ratio: 1
    }
]), _obj);
function ImageWithLabel(param) {
    var className = param.className, image = param.image, label = param.label, layout = param.layout, aboveTheFold = param.aboveTheFold;
    var labelStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_5__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalTextPreset.Label12SangBleu */ .C.Label12SangBleu,
        color: _types_colors__WEBPACK_IMPORTED_MODULE_2__/* .GlobalThemeColors.Black */ .b.Black
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ImageWithLabel), className),
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().image)),
                layout: layout === IMAGE_SIZE.LARGE ? "responsive" : "fill",
                ratio: layout === IMAGE_SIZE.SMALL ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ratio) : null,
                sizesFromBreakpoints: IMAGE_SIZES === null || IMAGE_SIZES === void 0 ? void 0 : IMAGE_SIZES[layout]
            }, layout === IMAGE_SIZE.LARGE ? {} : {
                objectFit: "cover"
            }, image), {
                priority: aboveTheFold
            })),
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figcaption", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label), labelStyle),
                children: label
            })
        ]
    });
}
ImageWithLabel.defaultProps = {};
/* harmony default export */ __webpack_exports__["ZP"] = (ImageWithLabel);


/***/ }),

/***/ 37923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Slices_PushTypeListing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/Slices/PushTypeListing/PushTypeListingItem/styles.module.scss
var styles_module = __webpack_require__(52597);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Slices/PushTypeListing/PushTypeListingItem/index.tsx








var cx = bind_default().bind((styles_module_default()));
function PushTypeListingItem(param) {
    var className = param.className, name = param.name, link = param.link, isLast = param.isLast, onMouseEnter = param.onMouseEnter, onMouseLeave = param.onMouseLeave;
    var linkStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.TitleFluid20_40SangBleu */.C.TitleFluid20_40SangBleu
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                className: cx((styles_module_default()).PushTypeListingItem, className, linkStyle),
                children: name
            })),
            !isLast && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: cx((styles_module_default()).separator, linkStyle),
                children: "—"
            })
        ]
    });
}
PushTypeListingItem.defaultProps = {};
/* harmony default export */ var PushTypeListing_PushTypeListingItem = (PushTypeListingItem);

// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/utils/chunk.ts
var chunk = __webpack_require__(17972);
// EXTERNAL MODULE: ./src/utils/maths/random.ts
var random = __webpack_require__(6877);
// EXTERNAL MODULE: ./src/components/Slices/PushTypeListing/styles.module.scss
var PushTypeListing_styles_module = __webpack_require__(31798);
var PushTypeListing_styles_module_default = /*#__PURE__*/__webpack_require__.n(PushTypeListing_styles_module);
;// CONCATENATED MODULE: ./src/components/Slices/PushTypeListing/index.tsx

















var PushTypeListing_cx = bind_default().bind((PushTypeListing_styles_module_default()));
var IMAGE_SIZES = [
    {
        ratio: 10 / 24
    }
];
function PushTypeListing(param) {
    var className = param.className, items = param.items, total = param.total, isManualMode = param.isManualMode, cta = param.cta, aboveTheFold = param.aboveTheFold;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(null), currentIndex = ref3[0], setCurrentIndex = ref3[1];
    var ref4 = (0,react.useState)(), imagePosition = ref4[0], setImagePosition = ref4[1];
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    (0,react.useEffect)(function() {
        var randomPosition = generateRandomPosition();
        setImagePosition(randomPosition);
    }, [
        currentIndex
    ]);
    var ref5;
    var chunkedItems = isManualMode ? items : (ref5 = (ref = (0,chunk/* default */.Z)(items, 25)) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref5 !== void 0 ? ref5 : [];
    var totalValueStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.TitleFluid24_40SangBleu */.C.TitleFluid24_40SangBleu,
        color: colors/* GlobalThemeColors.Scorpion */.b.Scorpion
    });
    var generateRandomPosition = function() {
        var Xkeys = [
            "left",
            "right"
        ];
        var Ykeys = [
            "top",
            "bottom"
        ];
        var randomXkey = Xkeys === null || Xkeys === void 0 ? void 0 : Xkeys[(0,random/* randomIntFromInterval */.l)(0, 1)];
        var randomYkey = Ykeys === null || Ykeys === void 0 ? void 0 : Ykeys[(0,random/* randomIntFromInterval */.l)(0, 1)];
        var randomXvalue = (0,random/* randomIntFromInterval */.l)(0, 50);
        var randomYvalue = (0,random/* randomIntFromInterval */.l)(0, 20);
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, randomXkey, "".concat(randomXvalue, "%")), (0,_define_property/* default */.Z)(_obj, randomYkey, "".concat(randomYvalue, "%")), _obj;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: PushTypeListing_cx((PushTypeListing_styles_module_default()).PushTypeListing, className),
        children: [
            currentIndex !== null && (chunkedItems === null || chunkedItems === void 0 ? void 0 : (ref1 = chunkedItems[currentIndex]) === null || ref1 === void 0 ? void 0 : ref1.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PushTypeListing_styles_module_default()).imageWrapper,
                style: imagePosition,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chunkedItems === null || chunkedItems === void 0 ? void 0 : (ref2 = chunkedItems[currentIndex]) === null || ref2 === void 0 ? void 0 : ref2.image), {
                    sizesFromBreakpoints: IMAGE_SIZES,
                    layout: "fill",
                    asPlaceholder: true,
                    className: (PushTypeListing_styles_module_default()).image,
                    priority: aboveTheFold,
                    objectFit: "contain"
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: PushTypeListing_cx((PushTypeListing_styles_module_default()).wrapper, gridStyle),
                children: [
                    (chunkedItems === null || chunkedItems === void 0 ? void 0 : chunkedItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PushTypeListing_styles_module_default()).typeItems,
                        children: [
                            chunkedItems.map(function(item, index) {
                                var isLast = index === chunkedItems.length - 1;
                                return /*#__PURE__*/ (0,react.createElement)(PushTypeListing_PushTypeListingItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    key: "designer_item_".concat(index),
                                    className: (PushTypeListing_styles_module_default()).item,
                                    isLast: isLast,
                                    onMouseEnter: function() {
                                        return setCurrentIndex(index);
                                    },
                                    onMouseLeave: function() {
                                        return setCurrentIndex(null);
                                    }
                                }));
                            }),
                            total - (chunkedItems === null || chunkedItems === void 0 ? void 0 : chunkedItems.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: PushTypeListing_cx((PushTypeListing_styles_module_default()).totalValue, totalValueStyle),
                                children: [
                                    "\xa0",
                                    "+ ".concat(total - (chunkedItems === null || chunkedItems === void 0 ? void 0 : chunkedItems.length), " ")
                                ]
                            }) : null
                        ]
                    }),
                    !isManualMode && cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PushTypeListing_styles_module_default()).ctaWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cta), {
                            className: (PushTypeListing_styles_module_default()).cta,
                            lineProps: {
                                initialLineState: "underlined"
                            }
                        }))
                    })
                ]
            })
        ]
    });
}
PushTypeListing.defaultProps = {};
/* harmony default export */ var Slices_PushTypeListing = (PushTypeListing);


/***/ }),

/***/ 87171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_grid_preset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31538);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95348);
/* harmony import */ var _components_UI_BannerImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4017);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24365);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default()));
function HeroFilteredPage(param) {
    var className = param.className, image = param.image, mobileImage = param.mobileImage, title = param.title, _size = param.size, size = _size === void 0 ? "medium" : _size;
    var gridStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_5__/* .useStyle */ .X)({
        grid: _types_grid_preset__WEBPACK_IMPORTED_MODULE_2__/* .GlobalGridPreset.BASE_GRID */ .H.BASE_GRID
    });
    var titleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_5__/* .useStyle */ .X)({
        textPreset: size === "big" ? _types_text_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalTextPreset.TitleFluid64_214SangBleu */ .C.TitleFluid64_214SangBleu : _types_text_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalTextPreset.TitleFluid38_144SangBleu */ .C.TitleFluid38_144SangBleu
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().HeroFilteredPage), className),
        children: [
            (image || mobileImage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_BannerImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bannerImage)),
                image: image,
                mobileImage: mobileImage
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content), gridStyle),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title), titleStyle),
                    children: title
                })
            })
        ]
    });
}
HeroFilteredPage.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (HeroFilteredPage);


/***/ }),

/***/ 81619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _lib_storyblok_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18685);
/* harmony import */ var _components_Slices_PushTypeListing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37923);



/* harmony default export */ __webpack_exports__["Z"] = ((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _lib_storyblok_types__WEBPACK_IMPORTED_MODULE_0__/* .STORYBLOK_SLICES.PUSH_DESIGNERS */ .zj.PUSH_DESIGNERS, _components_Slices_PushTypeListing__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 56323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _pages_metals_stones_uid___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29877);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (_pages_metals_stones_uid___WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ 29877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _imports_designer_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81619);
/* harmony import */ var _unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92665);
/* harmony import */ var _components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68971);
/* harmony import */ var _components_PageWithFilters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5560);
/* harmony import */ var _components_UI_HeroFilteredPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87171);









function DesignerPage(_param) {
    var slices = _param.slices, heroData = _param.heroData, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "slices",
        "heroData"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_HeroFilteredPage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, heroData)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageWithFilters__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                customLayout: true
            }, props), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_8__/* .SliceManager */ .y, {
                    mapSliceTypeToComponent: _imports_designer_page__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
                    slicesData: slices
                })
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .W, {
                template: "collection"
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (DesignerPage);


/***/ }),

/***/ 6877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ randomIntFromInterval; }
/* harmony export */ });
function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}


/***/ }),

/***/ 72487:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ImageWithLabel":"styles_ImageWithLabel__jKQDs","image":"styles_image__8TMZJ","label":"styles_label__68sUM","ratio":"styles_ratio__X_Jq0"};

/***/ }),

/***/ 52597:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PushTypeListingItem":"styles_PushTypeListingItem__Rv_EY","separator":"styles_separator__gG__C"};

/***/ }),

/***/ 31798:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PushTypeListing":"styles_PushTypeListing__nyNXu","imageWrapper":"styles_imageWrapper__FuDLc","image":"styles_image__EH0uH","wrapper":"styles_wrapper__2yB_L","typeItems":"styles_typeItems__MgQ72","ctaWrapper":"styles_ctaWrapper__8ZONW"};

/***/ }),

/***/ 24365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroFilteredPage":"styles_HeroFilteredPage__8ntzW","title":"styles_title__YkjBd","image":"styles_image__e3j8f","content":"styles_content___ifDt"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,7130,565,2873,3816,4109,9774,2888,179], function() { return __webpack_exec__(44890); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);